import LayoutProductGrid from 'components/Content/ContentLayout/LayoutProductGrid';
import LayoutOpen from 'components/Content/ContentLayout/LayoutOpen';
import LayoutCreditCardApplication from 'components/Content/ContentLayout/LayoutCreditCardApplication';
import LayoutCreditCardPage from 'components/Content/ContentLayout/LayoutCreditCardPage';
import LayoutBuyingGuide from 'components/Content/ContentLayout/LayoutBuyingGuide';
import LayoutDirectory from 'components/Content/ContentLayout/LayoutDirectory';
import LayoutCs from 'components/Content/ContentLayout/LayoutCs';
import LayoutRewardsBazaar from 'components/Content/ContentLayout/LayoutRewardsBazaar';
import LayoutBeautyInsider from 'components/Content/ContentLayout/LayoutBeautyInsider';
import LayoutARSkincare from 'components/Content/ContentLayout/LayoutARSkincare';

export default {
    LayoutProductGrid,
    LayoutOpen,
    LayoutBuyingGuide,
    LayoutDirectory,
    LayoutCs,
    LayoutCreditCardApplication,
    LayoutCreditCardPage,
    LayoutRewardsBazaar,
    LayoutBeautyInsider,
    LayoutARSkincare
};
